import { calculateMaxScores } from "./calculate-max-scores";
import { getCoreSectionScores } from "./core-sections";
import { getEducationScore } from "./core-sections/education";
import { getPersonalDetailsScore } from "./core-sections/personal-details";
import { getProjectScore } from "./core-sections/project";
import { getSkillScore } from "./core-sections/skill";
import { getExperienceScore } from "./core-sections/work-exerience";
import { getNonCoreSectionScore } from "./non-core-sections/non-core-section-score";
import { getOverallSectionScore } from "./overall-analysis-score";
import { ResumeAnalysis } from "./resume-analysis/resume-analyse-types";
import { ScoreAnalysis } from "./types";
export type ExperienceLevel = 'FRESHER' | 'EXPERIENCED';
export const scoreResume = (resume: ResumeAnalysis, experienceLevel: ExperienceLevel): ScoreAnalysis => {
  const maxScores = calculateMaxScores(resume, experienceLevel);
  const maxNonCoreSectionScore = maxScores.maxNonCoreSectionScore;
  const coreSections = maxScores.coreSections
  const projectsMaxScore = coreSections.projectsMaxScore;
  const experienceMaxScore = coreSections.experienceMaxScore;
  const educationMaxScore = coreSections.educationMaxScore;
  const skillsMaxScore = coreSections.skillsMaxScore;
  const personalDetailsMaxScore = coreSections.personalDetailsMaxScore;
  const overallMaxScore = maxScores.maxOverAllScore;


  const coreScores = getCoreSectionScores(resume, coreSections);
  const coreSectionScore = coreScores.totalScore;
  const nonCoreSectionResult = getNonCoreSectionScore(resume, maxNonCoreSectionScore);
  const nonCoreSectionScore = nonCoreSectionResult.totalScore;
  const overallResult = getOverallSectionScore(resume, overallMaxScore);
  const overAllScore = overallResult.overallScore;

  const projectsScore = getProjectScore(resume.projects, projectsMaxScore);
  const experienceScore = getExperienceScore(resume.workExperiences, experienceMaxScore);
  const educationScore = getEducationScore(resume.educations, educationMaxScore);
  const skillsScore = getSkillScore(resume.skills, skillsMaxScore)
  const personalDetailsScore = getPersonalDetailsScore(resume.profile, personalDetailsMaxScore)

  // Calculate the capped total score
  const totalScore = nonCoreSectionResult.totalScore + projectsScore.totalScore + experienceScore.totalScore + educationScore.totalScore + skillsScore.totalScore + personalDetailsScore.totalScore + overallResult.overallScore;

  return {
    totalScore: Math.min(Math.floor(totalScore), 100),
    projectsMaxScore: Math.floor(projectsMaxScore),
    experienceMaxScore: Math.floor(experienceMaxScore),
    educationMaxScore: Math.floor(educationMaxScore),
    skillsMaxScore: Math.floor(skillsMaxScore),
    personalDetailsMaxScore: Math.floor(personalDetailsMaxScore),
    overallMaxScore: Math.floor(overallMaxScore),
    personalDetailsScore,
    educationScore,
    experienceScore,
    projectsScore,
    skillsScore,
    coreSectionScore: Math.min(Math.floor(coreSectionScore), 100),
    nonCoreSectionScore: Math.min(Math.floor(nonCoreSectionScore), maxNonCoreSectionScore),
    overAllScore: Math.min(Math.floor(overAllScore), overallMaxScore),
    maxScores
  };

}
